export { CollectionTitleDS } from './collection-title-ds'
export type { CollectionTitleDSProps } from './collection-title-ds.types'
